import React from 'react';
import PropTypes from 'prop-types';
import styles from './RawHtml.module.scss';

const RawHtml = ({ html = '' }) => <div className={styles['Container']} dangerouslySetInnerHTML={{ __html: html }} />;

RawHtml.propTypes = {
    html: PropTypes.string.isRequired,
};

export default RawHtml;
